import Axios from "axios";
import { Field as Fieldmik, FieldArray, Form, Formik } from "formik";
import React, { Component } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Divider, Input, TextArea, Modal } from "semantic-ui-react";
import { DateData } from "../../../components/apiInputs/dateData";
import MyFromLocation from "../../../components/apiInputs/fromLocation";
import MyCustomerType from "../../../components/apiInputs/myCustomerType";
import MyCategory from "../../../components/apiInputs/myCategory";
import MyBusinessType from "../../../components/apiInputs/myBusinessType";
import MyOrderType from "../../../components/apiInputs/myOrderType";
import MyToLocation from "../../../components/apiInputs/toLocation";
/* import ReadAxios, {
  GetBaseUrl,
} from "../../../components/axiosComponent/read"; */
import ReadAxios from "../../axiosComponent/read";
import allAxiosCommonRequest from "../../axiosComponent/allAxiosCommonRequest";

import {
  MyDropdown,
  MyNormalInput,
  MyTextArea,
} from "../../../components/dynamicComponent/myInputs.js";
import APP_CONSTANT from "../../../config/constants";
import MyConsignorMaster from "../../../components/apiInputs/consignorMaster";
import MyConsigneeMaster from "../../../components/apiInputs/consigneeMaster";
import MyVehicle from "../../../components/apiInputs/myVehicle";
import MySku from "../../../components/apiInputs/mySku";
import LoadingPlaceholder from "../../../components/common/loading_placeholder";
import MyPackingType from "../../../components/apiInputs/myPackingType";
import moment from "moment";
import * as yup from "yup";
import MyBillingParty from "../../../components/apiInputs/myBillingParty";
import MyBillingPartyBranch from "../../../components/apiInputs/myBillingPartyBranch";
import { FaTrash } from "react-icons/fa";
import MyPSLineItem from "../../../components/apiInputs/mypslineItem";
import MyBranch from "../../../components/apiInputs/myBranch";
export default class VendorLrModal extends Component {
  state = {
    lrInfo: [],
    edit: false,
    totalValue: 0,
    isPdf: false,
    lrData:[]
  };
  componentDidMount() {
    allAxiosCommonRequest({
      url: "lr/get",
      method: "post",
      Items: {
        lrNo: this.props.dataLRModal.lr_id,
        startDate: "01-03-2021",
        endDate: "23-03-2021",
      },
    })
      .then((response) => {
        this.setState({ lrInfo: response.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  componentDidUpdate(prevProps) {
    console.log("dataLRModal",this.props.dataLRModal)
    if (this.props.dataLRModal != prevProps.dataLRModal) {
      // console.log("inside If",prevProps.dataLRModal)
      this.setState({ lrData: this.props.dataLRModal });
    }
  }
  edit = () => {
    this.setState({ edit: !this.state.edit });
  };
  pdf = () => {
    this.setState({
      isPdf: true,
    });
    ReadAxios({
      url: "lr/generatePdf",
      readItems: {
        lrNo: this.props.dataLRModal.lr_id,
        roleName: localStorage.getItem('role')
      },
    }).then((response) => {
      let url = response;
      this.setState({
        isPdf: false,
      });
      window.open(url, "_blank");
    });
  };
  formatGoods = (data) => {
    return data.map((o, i) => {
      return {
        goodsCode: o.goodsCode,
        packagingCode: o.packingTypeCode,
        categoryCode: o.categoryCode,
        quantity: o.quantity,
      };
    });
  };
  formatLrInvoices = (data) => {
    // console.log('>>', JSON.stringify(data))
    return data.map((o, i) => {
      return {
        ewayBillNumber: o.ewayBillNumber,
        ewayBillExpiryDate:
          o.ewayBillExpiryDate && moment(o.ewayBillExpiryDate, "DD-MM-YYYY"),
        goodsValue: o.goodsValue,
        goodsInvoiceNo: o.goodsInvoiceNo,
        BoENo: o.BoENo,
        BoEDate: o.BoEDate,
        goodsInvoiceDate:
          o.goodsInvoiceDate && moment(o.goodsInvoiceDate, "DD-MM-YYYY"),
        lrGoodsDetails: this.formatGoods(o.goods_details),
      };
    });
  };
  formatCharges = (data) => {
    // console.log('>>', JSON.stringify(data))
    return data.map((o, i) => {
      return {
        chargeId: o.chargeId,
        cityId: o.cityId,
        otherCharges: o.otherCharges,
      };
    });
  };
  totalamount = (val, obj) => {
    // let arr = []
    // let combine =  obj.otherCharges
    // console.log(combine)
  };
  render() {
    const { lrInfo,lrData, edit } = this.state;
    // console.log("dataLRModal--->>",this.props.dataLRModal)
    console.log("lrData--->>",lrData?.[0]?.lrDate)
    let validationSchema = yup.object({
      minTemp: yup
        .number()
        .optional()
        .nullable()
        .max(yup.ref("maxTemp"), "Must be less than max temp."),
      maxTemp: yup
        .number()
        .optional()
        .nullable()
        .min(yup.ref("minTemp"), "Must be greater than min temp."),
    });

    let deliveryOptions = [
      { key: "1", text: "Consignee", value: "Consignee" },
      { key: "2", text: "Branch", value: "Branch" },
      { key: "3", text: "Other", value: "Other" },
    ];

    if (lrData && lrData.length === 0) {
      return (
        <>
          <Modal
            size="fullscreen"
            open={this.props.show}
            onClose={this.props.handleClose}
            style={{ position: "absolute", top: "0px!important" }}
          >
            <Modal.Header>
              <div className="d-flex justify-content-between">
                <div>
                  <div>LR Details</div>
                  <div>
                    <Button
                      onClick={this.edit}
                      size="sm"
                      variant="outline-success"
                      style={{ position: "absolute", right: "3em" }}
                    >
                      {edit ? (
                        <i className="fa fa-times"></i>
                      ) : (
                        <i className="fa fa-edit"></i>
                      )}
                    </Button>
                    <Button
                      disabled={this.state.isPdf}
                      onClick={this.pdf}
                      size="sm"
                      variant="outline-warning"
                      style={{ position: "absolute", right: "6em" }}
                    >
                      {this.state.isPdf ? (
                        <Spinner variant="warning" animation="border" />
                      ) : (
                        <i className="fa fa-download"></i>
                      )}
                    </Button>
                  </div>
                </div>
                <div className="form-inline">
                  <i
                    onClick={this.props.handleClose}
                    className="fas fa-times"
                  ></i>
                </div>
              </div>
            </Modal.Header>
            <Modal.Content>
              {/* <LoadingPlaceholder /> */}
              <center>
                <Spinner animation="grow" variant="success" />
                <Spinner animation="grow" variant="danger" />
                <Spinner animation="grow" variant="warning" />
              </center>
            </Modal.Content>
          </Modal>
        </>
      );
    } else {
      // console.log(lrData[0].billingPartyId)
      return (
        <div>
          <Modal
            size="fullscreen"
            open={this.props.show}
            onClose={this.props.handleClose}
            style={{ position: "absolute", top: "0px!important" }}
          >
            <Modal.Header>
              <div className="d-flex justify-content-between">
                <div>
                  <div>LR Details</div>
                  <div>
                    <Button
                      onClick={this.edit}
                      size="sm"
                      variant="outline-success"
                      style={{ position: "absolute", right: "3em" }}
                    >
                      {edit ? (
                        <i className="fa fa-ban"></i>
                      ) : (
                        <i className="fa fa-edit"></i>
                      )}
                    </Button>
                    <Button
                      disabled={this.state.isPdf}
                      onClick={this.pdf}
                      size="sm"
                      variant="outline-warning"
                      style={{ position: "absolute", right: "6em" }}
                    >
                      {this.state.isPdf ? (
                        <Spinner
                          size="sm"
                          variant="warning"
                          animation="border"
                        />
                      ) : (
                        <i className="fa fa-download"></i>
                      )}
                    </Button>
                  </div>
                </div>
                <div className="form-inline">
                  <i
                    onClick={this.props.handleClose}
                    className="fas fa-times"
                  ></i>
                </div>
              </div>
            </Modal.Header>
            <Modal.Content scrolling>
              <Formik
                enableReinitialize
                initialValues={{
                  // lrData.length > 0 ?  :
                  lrId: lrData[0].lrId,
                  lrNo: lrData[0].lrNo,
                  lrDate: moment(lrData[0].lrDate, "DD-MM-YYYY"),
                  orderType:
                    lrData[0].orderTypeName &&
                    lrData[0].orderTypeName.toLowerCase(),
                  businessType:
                    lrData[0].businessTypeName &&
                    lrData[0].businessTypeName.toLowerCase(),
                  fromCityCode: lrData[0].fromCityCode,
                  fromCityName: lrData[0].fromCity,
                  toCityCode: lrData[0].toCityCode,
                  toCityName: lrData[0].toCity,
                  billingPartyCode:
                    lrData[0].billingPartyCode == 0
                      ? ""
                      : lrData[0].billingPartyCode,
                  billingPartyBranchCode: lrData[0].billingPartyBranchCode,
                  billingPartyId: lrData[0].billingPartyId,
                  billingPartyBranchId: lrData[0].billingPartyBranchId,
                  branchCode:
                    lrData[0].branchCode == "null" ? "" : lrData[0].branchCode,
                  consignorCode: lrData[0].consignorCode,
                  consigneeCode: lrData[0].consigneeCode,
                  ownershipType: lrData[0].ownershipType,
                  vehicleTypeCode: lrData[0].vehicleType,
                  vendorCode: lrData[0].transporterName,
                  minTemp: lrData[0].minTemp,
                  panNo: lrData[0].panNo,
                  gstNo: lrData[0].gstNo,
                  maxTemp: lrData[0].maxTemp,
                  vehicleNo: lrData[0].vehicleNo,
                  actualWeight: lrData[0].actualWeight,
                  grossWeight: lrData[0].grossWeight,
                  shipmentInsuredBy: lrData[0].shipmentInsuredBy,
                  frieghtAmount: lrData[0].frieghtAmount,
                  totalFreightAmount: +lrData[0].totalFreightAmount,
                  billingPartyType: lrData[0].billingPartyType,
                  containerNumber: lrData[0].containerNumber,
                  sealNumber: lrData[0].sealNumber,
                  chargedWeight: lrData[0].chargedWeight,
                  shippingLineCode: lrData[0].shippingLine,
                  DONumber: lrData[0].DONumber,
                  port: lrData[0].port,
                  deliveryTo: lrData[0].deliveryTo,
                  deliveryAddress: lrData[0].deliveryAddress,
                  containerSize: lrData[0].containerSize,
                  containerType: lrData[0].containerType,
                  remarks: lrData[0].remarks,
                  lrOtherCharges: this.formatCharges(
                    lrData[0].cn_other_charges
                  ),
                  lrInvoiceNoDetails: this.formatLrInvoices(
                    lrData[0].cn_invoice_details
                  ),
                  customerNo: localStorage.getItem("customerNo"),
                  userId: localStorage.getItem("userId"),
                  consigneePhone: lrData[0].consigneePhone,
                  consignee: lrData[0].consigneeCode,
                  consigneeAddress: lrData[0].consigneeAddress,
                  consigneeCityName: lrData[0].consigneeCityName,
                  consigneePincode: lrData[0].consigneePincode,
                  consignorPhone: lrData[0].consignorPhone,
                  consignor: lrData[0].consignorCode,
                  consignorAddress: lrData[0].consignorAddress,
                  consignorCityName: lrData[0].consignorCityName,
                  consignorPincode: lrData[0].consignorPincode,
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  let gett = localStorage.getItem("isloggedIn");
                  let fromCityCode = values.fromCityCode.code
                    ? values.fromCityCode.code
                    : values.fromCityCode;
                  let toCityCode = values.toCityCode.code
                    ? values.toCityCode.code
                    : values.toCityCode;
                  let businessType = values.businessType
                    ? values.businessType.toUpperCase()
                    : lrData[0].businessTypeName &&
                      lrData[0].businessTypeName.toUpperCase();
                  let lrDate = values.lrDate
                    ? moment(values.lrDate).format("DD-MM-YYYY")
                    : lrData[0].orderTypeName;
                  let orderType = values.orderType
                    ? values.orderType.toUpperCase()
                    : lrData[0].orderTypeName.toUpperCase();
                  let combine = {
                    ...values,
                    fromCityCode,
                    toCityCode,
                    businessType,
                    orderType,
                    lrDate,
                  };
                  Axios.post(`${APP_CONSTANT.BASE_COMMON}lr/update`, combine, {
                    headers: {
                      "content-type": "application/json",
                      Authorization: `${gett}`,
                    },
                  })
                    .then((response) => {
                      // console.log('>>>', response)
                      if (response.data.status === 1) {
                        window.location.reload();
                        // alert(response.data.message)
                      } else {
                        setSubmitting(false);
                        alert(response.data.message);
                      }
                    })
                    .catch((err) => console.log(err));
                }}
              >
                {({ values, isSubmitting, touched, errors }) => {
                  return (
                    <Form className="form ui">
                      <div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>LR No *</b>
                              </label>
                              <Fieldmik
                                transparent={!edit}
                                readOnly={!edit}
                                component={MyNormalInput}
                                size="mini"
                                fluid
                                name="lrNo"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>LR Date *</b>
                              </label>
                              <span className="full-width-date">
                                <DateData
                                  autoComplete="off"
                                  name="lrDate"
                                  popperClassName="dateTime"
                                  dateFormat="dd-MM-yyyy"
                                  selected={values.lrDate}
                                  selectsStart
                                  maxDate={new Date()}
                                  readOnly={!edit}
                                  customInput={
                                    <Input
                                      transparent={!edit}
                                      size="mini"
                                      fluid
                                      autoComplete="off"
                                    />
                                  }
                                />
                                
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>From City *</b>
                              </label>
                              <Fieldmik
                                text={lrData[0].fromCityName}
                                selection={edit}
                                icon={edit == false ? null : "dropdown"}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                clearable
                                placeholder={lrData[0].fromCityName}
                                component={MyFromLocation}
                                name="fromCityCode"
                                type="text"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>To City *</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                clearable
                                placeholder={lrData[0].toCityName}
                                component={MyToLocation}
                                name="toCityCode"
                                type="text"
                              />
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Delivery To</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                value={values.deliveryTo}
                                className="w3-small p-placeholder  disabledField"
                                options={deliveryOptions}
                                component={MyDropdown}
                                name="deliveryTo"
                                type="text"
                              />
                            </div>
                          </div>
                          {values.deliveryTo == "Branch" ? (
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="w3-small">
                                  <b>Branch</b>
                                </label>
                                <Fieldmik
                                  size="mini"
                                  icon={edit == false ? null : "dropdown"}
                                  selection={edit}
                                  address="deliveryAddress"
                                  disabled={!edit}
                                  className="w3-small p-placeholder  disabledField"
                                  value={values.branchCode}
                                  component={MyBranch}
                                  name="branchCode"
                                  type="text"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Delivery Address</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                readOnly
                                style={{
                                  border: edit == false ? "none" : "",
                                  resize: edit == false ? "none" : "",
                                }}
                                className="w3-small p-placeholder  disabledField"
                                component={MyTextArea}
                                name="deliveryAddress"
                                type="text"
                              />
                            </div>
                          </div>
                          {values.deliveryTo == "Branch" ? (
                            ""
                          ) : (
                            <div className="col-md-2"></div>
                          )}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Vehicle Number *</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                clearable
                                vehId={lrData[0].vendorId}
                                vehicleType={(data) => null}
                                component={MyVehicle}
                                name="vehicleNo"
                                type="text"
                                placeholder={values.vehicleNo}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Business Type</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                value={values.businessType}
                                component={MyBusinessType}
                                name="businessType"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Order Type </b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                value={values.orderType}
                                component={MyOrderType}
                                name="orderType"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Actual Weight</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly={!edit}
                                className="w3-small"
                                component={MyNormalInput}
                                name="actualWeight"
                                type="number"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Gross Weight</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly={!edit}
                                className="w3-small"
                                component={MyNormalInput}
                                name="grossWeight"
                                type="number"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Minimum Temperature</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly={!edit}
                                className="w3-small"
                                type="number"
                                component={MyNormalInput}
                                name="minTemp"
                                placeholder=""
                              />
                              {touched.minTemp && errors.minTemp ? (
                                <small className="form-text text-muted w3-tiny w3-text-red">
                                  {errors.minTemp}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Maximum Temperature</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly={!edit}
                                className="w3-small"
                                type="number"
                                component={MyNormalInput}
                                name="maxTemp"
                                placeholder=""
                              />
                              {touched.maxTemp && errors.maxTemp ? (
                                <small className="form-text text-muted w3-tiny w3-text-red">
                                  {errors.maxTemp}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Freight Amount *</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly={!edit}
                                className="w3-small"
                                fluid
                                component={MyNormalInput}
                                name="frieghtAmount"
                                type="number"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Shipment Insured By</b>
                              </label>
                              <Fieldmik
                                options={[
                                  {
                                    key: 1,
                                    text: "Consignee",
                                    value: 1,
                                  },
                                  {
                                    key: 2,
                                    text: "Consignor",
                                    value: 2,
                                  },
                                  {
                                    key: 3,
                                    text: "Transporter",
                                    value: 3,
                                  },
                                  {
                                    key: 4,
                                    text: "None",
                                    value: 4,
                                  },
                                ]}
                                disabled={!edit}
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                value={values.shipmentInsuredBy}
                                component={MyDropdown}
                                className="w3-small p-placeholder  disabledField"
                                size="mini"
                                fluid
                                name="shipmentInsuredBy"
                              />
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-6"></div>
                          <div className="col-md-12">
                            <FieldArray
                              name="lrOtherCharges"
                              render={(otherHelpersRender) => {
                                var arr = [];
                                return (
                                  <>
                                    {/* {values.lrOtherCharges.length > 0 ? */}
                                    {values.lrOtherCharges.map(
                                      (object, index) => {
                                        arr.push(+object.otherCharges);
                                        let sum = arr.reduce((a, b) => a + b);
                                        {
                                          /* console.log(sum) */
                                        }
                                        values.totalFreightAmount =
                                          sum + parseInt(values.frieghtAmount);
                                        {
                                          /* values.totalFreightAmount += parseInt(object.otherCharges) + parseInt(values.frieghtAmount) */
                                        }
                                        return (
                                          <div className="row">
                                            <div className="col-md-3">
                                              <div className="form-group">
                                                <label className="w3-small">
                                                  <b>Other Charges </b>
                                                </label>
                                                <br />
                                                <Fieldmik
                                                  icon={
                                                    edit == false
                                                      ? null
                                                      : "dropdown"
                                                  }
                                                  selection={edit}
                                                  size="mini"
                                                  disabled={!edit}
                                                  className="w3-small p-placeholder  disabledField"
                                                  fluid
                                                  value={
                                                    values.lrOtherCharges[index]
                                                      .chargeId
                                                  }
                                                  component={MyPSLineItem}
                                                  lrMode={true}
                                                  name={`lrOtherCharges[${index}].chargeId`}
                                                  type="number"
                                                  placeholder=""
                                                />
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="form-group">
                                                <label className="w3-small">
                                                  <b>Amount </b>
                                                </label>
                                                <br />
                                                <Fieldmik
                                                  transparent={!edit}
                                                  size="mini"
                                                  min="0"
                                                  value={
                                                    values.lrOtherCharges[index]
                                                      .otherCharges
                                                  }
                                                  readOnly={!edit}
                                                  className="w3-small"
                                                  fluid
                                                  component={MyNormalInput}
                                                  name={`lrOtherCharges[${index}].otherCharges`}
                                                  type="number"
                                                  placeholder=""
                                                />
                                              </div>
                                            </div>
                                            <div className="col-md-2">
                                              <div className="form-group">
                                                <label className="w3-small">
                                                  <b>&nbsp;</b>
                                                </label>
                                                <br />
                                                {index === 0 ? (
                                                  ""
                                                ) : (
                                                  <Button
                                                    disabled={!edit}
                                                    onClick={() =>
                                                      otherHelpersRender.remove(
                                                        index
                                                      )
                                                    }
                                                    variant="outline-danger"
                                                  >
                                                    {" "}
                                                    <FaTrash />{" "}
                                                  </Button>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                    {/* : ''} */}
                                    <Button
                                      disabled={!edit}
                                      onClick={() =>
                                        otherHelpersRender.push({
                                          chargeId: "",
                                          cityId: "0",
                                          otherCharges: "",
                                        })
                                      }
                                      variant="outline-info"
                                      size="sm"
                                      className="w3-round-large"
                                    >
                                      {" "}
                                      + Add Other Charges{" "}
                                    </Button>
                                  </>
                                );
                              }}
                            />
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Total Freight Value</b>
                              </label>
                              <br />
                              <Fieldmik
                                size="mini"
                                transparent={!edit}
                                readOnly
                                className="w3-small"
                                fluid
                                component={MyNormalInput}
                                name="totalFreightAmount"
                                type="number"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <Divider horizontal>
                            <span className="w3-text-blue w3-tiny">
                              Consignor Details
                            </span>
                          </Divider>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor Name *</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                id="consignorId"
                                address="consignorAddress"
                                code="consignor"
                                cityName="consignorCityName"
                                phone="consignorPhone"
                                pincode="consignorPincode"
                                dataId={lrData[0].consignorId}
                                component={MyConsignorMaster}
                                name="consignorCode"
                                type="text"
                                defaultValue={values.consignorCode}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor Code</b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                name="consignor"
                                size="mini"
                                readOnly
                                className="w3-small"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor Mobile Number </b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                name="consignorPhone"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor GST</b>
                              </label>
                              <br />
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                type="text"
                                name="consignorGst"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor Address</b>
                              </label>
                              <Fieldmik
                                component={MyTextArea}
                                size="mini"
                                style={{
                                  border: edit == false ? "none" : "",
                                  resize: edit == false ? "none" : "",
                                }}
                                readOnly
                                className="w3-small"
                                name="consignorAddress"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor City </b>
                              </label>
                              <br />
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small p-placeholder"
                                name="consignorCityName"
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignor Pincode</b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                name="consignorPincode"
                              />
                            </div>
                          </div>
                          <Divider horizontal>
                            <span className="w3-text-blue w3-tiny">
                              Consignee Details
                            </span>
                          </Divider>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee Name *</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                disabled={!edit}
                                className="w3-small p-placeholder  disabledField"
                                id="consigneeId"
                                address="consigneeAddress"
                                code="consignee"
                                cityName="consigneeCityName"
                                phone="consigneePhone"
                                pincode="consigneePincode"
                                component={MyConsigneeMaster}
                                dataId={lrData[0].consigneeId}
                                name="consigneeCode"
                                type="text"
                                defaultValue={values.consigneeCode}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee Code</b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                name="consignee"
                                size="mini"
                                readOnly
                                className="w3-small"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee Mobile Number </b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                name="consigneePhone"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee GST</b>
                              </label>
                              <br />
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                type="text"
                                name="consigneeGst"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee Address</b>
                              </label>
                              <Fieldmik
                                component={MyTextArea}
                                size="mini"
                                style={{
                                  border: edit == false ? "none" : "",
                                  resize: edit == false ? "none" : "",
                                }}
                                readOnly
                                className="w3-small"
                                name="consigneeAddress"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee City </b>
                              </label>
                              <br />
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small p-placeholder"
                                name="consigneeCityName"
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Consignee Pincode</b>
                              </label>
                              <Fieldmik
                                component={MyNormalInput}
                                transparent={!edit}
                                size="mini"
                                readOnly
                                className="w3-small"
                                name="consigneePincode"
                              />
                            </div>
                          </div>
                          <Divider horizontal>
                            <span className="w3-text-blue w3-tiny">
                              Customer Details
                            </span>
                          </Divider>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Billing Party</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                fluid
                                className="w3-small p-placeholder  disabledField"
                                disabled={!edit}
                                dataId="billingPartyId"
                                value={values.billingPartyCode}
                                component={MyBillingParty}
                                name="billingPartyCode"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Billing Party Branch</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                fluid
                                className="w3-small p-placeholder  disabledField"
                                id={values.billingPartyId}
                                gst="gstNo"
                                pan="panNo"
                                disabled={!edit}
                                value={values.billingPartyBranchCode}
                                component={MyBillingPartyBranch}
                                name="billingPartyBranchCode"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Customer Type</b>
                              </label>
                              <Fieldmik
                                icon={edit == false ? null : "dropdown"}
                                selection={edit}
                                size="mini"
                                fluid
                                className="w3-small disabledField"
                                disabled={!edit}
                                lrMode={true}
                                value={values.billingPartyType}
                                component={MyCustomerType}
                                name="billingPartyType"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>PAN Number</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                fluid
                                className="w3-small"
                                transparent={!edit}
                                readOnly={!edit}
                                value={values.panNo != null ? values.panNo : ""}
                                component={MyNormalInput}
                                name="panNo"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>GST Number</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                fluid
                                className="w3-small"
                                transparent={!edit}
                                readOnly={!edit}
                                component={MyNormalInput}
                                value={values.gstNo != null ? values.gstNo : ""}
                                name="gstNo"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <Divider horizontal>
                            <span className="w3-text-blue w3-tiny">
                              E-way Details & Product Details
                            </span>
                          </Divider>
                          <div className="col-md-12">
                            <FieldArray
                              name="lrInvoiceNoDetails"
                              render={(arrayHelpers) => (
                                <>
                                  {values.lrInvoiceNoDetails.map(
                                    (object, index) => (
                                      <div className="row">
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>E-Way Bill Number</b>
                                            </label>
                                            <Fieldmik
                                              size="mini"
                                              transparent={!edit}
                                              readOnly={!edit}
                                              name={`lrInvoiceNoDetails[${index}].ewayBillNumber`}
                                              component={MyNormalInput}
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>E-Way Bill Expiry Date</b>
                                            </label>
                                            <span className="full-width-date">
                                              {/* <Fieldmik size="mini" readOnly={!edit} name={`ewayBillExpiryDate`} component={MyNormalInput} /> */}
                                              <DateData
                                                autoComplete="off"
                                                name={`lrInvoiceNoDetails[${index}].ewayBillExpiryDate`}
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                selected={
                                                  values.ewayBillExpiryDate
                                                }
                                                selectsStart
                                                maxDate={new Date()}
                                                readOnly={!edit}
                                                customInput={
                                                  <Input
                                                    transparent={!edit}
                                                    size="mini"
                                                    fluid
                                                    autoComplete="off"
                                                  />
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>Goods Invoice No</b>
                                            </label>
                                            <Fieldmik
                                              size="mini"
                                              transparent={!edit}
                                              readOnly={!edit}
                                              name={`lrInvoiceNoDetails[${index}].goodsInvoiceNo`}
                                              component={MyNormalInput}
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>Goods Value</b>
                                            </label>
                                            <Fieldmik
                                              size="mini"
                                              transparent={!edit}
                                              type="number"
                                              readOnly={!edit}
                                              name={`lrInvoiceNoDetails[${index}].goodsValue`}
                                              component={MyNormalInput}
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>Goods Invoice Date</b>
                                            </label>
                                            {/* <Fieldmik size="mini" readOnly={!edit} name={`lrInvoiceNoDetails[${index}].goodsInvoiceDate`} component={MyNormalInput} /> */}
                                            <span className="full-width-date">
                                              <DateData
                                                autoComplete="off"
                                                name={`lrInvoiceNoDetails[${index}].goodsInvoiceDate`}
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                selected={
                                                  values.lrInvoiceNoDetails[
                                                    index
                                                  ].goodsInvoiceDate
                                                }
                                                selectsStart
                                                maxDate={new Date()}
                                                readOnly={!edit}
                                                customInput={
                                                  <Input
                                                    transparent={!edit}
                                                    size="mini"
                                                    fluid
                                                    autoComplete="off"
                                                  />
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-md-2">
                                          <div className="form-group">
                                            <label className="w3-small">
                                              <b>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                            </label>{" "}
                                            <br />
                                            <Button
                                              disabled={!edit}
                                              hidden={
                                                index === 0 ? true : false
                                              }
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                              size="sm"
                                              variant="outline-danger"
                                            >
                                              <i className="fa fa-trash"></i>
                                            </Button>
                                          </div>
                                        </div>
                                        <div className="col-md-12">
                                          <FieldArray
                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails`}
                                            render={(arrayGoods) => (
                                              <div className="row">
                                                {values.lrInvoiceNoDetails[
                                                  index
                                                ].lrGoodsDetails.map(
                                                  (object, i) => (
                                                    <>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>Product Name</b>
                                                          </label>
                                                          <Fieldmik
                                                            className="w3-small p-placeholder  disabledField"
                                                            icon={
                                                              edit == false
                                                                ? null
                                                                : "dropdown"
                                                            }
                                                            selection={edit}
                                                            value={
                                                              values
                                                                .lrInvoiceNoDetails[
                                                                index
                                                              ].lrGoodsDetails[
                                                                i
                                                              ].goodsCode
                                                            }
                                                            size="mini"
                                                            disabled={!edit}
                                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails[${i}].goodsCode`}
                                                            component={MySku}
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>Product Code</b>
                                                          </label>
                                                          <Fieldmik
                                                            size="mini"
                                                            transparent={!edit}
                                                            readOnly
                                                            className="p-placeholder disabledField"
                                                            placeholder={
                                                              values
                                                                .lrInvoiceNoDetails[
                                                                index
                                                              ].lrGoodsDetails[
                                                                i
                                                              ].goodsCode
                                                            }
                                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails[${i}].goodsCode`}
                                                            component={
                                                              MyNormalInput
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>Packing Type</b>
                                                          </label>
                                                          <Fieldmik
                                                            icon={
                                                              edit == false
                                                                ? null
                                                                : "dropdown"
                                                            }
                                                            selection={edit}
                                                            size="mini"
                                                            disabled={!edit}
                                                            value={
                                                              values
                                                                .lrInvoiceNoDetails[
                                                                index
                                                              ].lrGoodsDetails[
                                                                i
                                                              ].packagingCode
                                                            }
                                                            className="w3-small p-placeholder  disabledField"
                                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails[${i}].packagingCode`}
                                                            component={
                                                              MyPackingType
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>Category</b>
                                                          </label>
                                                          <Fieldmik
                                                            icon={
                                                              edit == false
                                                                ? null
                                                                : "dropdown"
                                                            }
                                                            selection={edit}
                                                            size="mini"
                                                            disabled={!edit}
                                                            className="w3-small p-placeholder  disabledField"
                                                            value={
                                                              values
                                                                .lrInvoiceNoDetails[
                                                                index
                                                              ].lrGoodsDetails[
                                                                i
                                                              ].categoryCode
                                                            }
                                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails[${i}].categoryCode`}
                                                            component={
                                                              MyCategory
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>Quantity</b>
                                                          </label>
                                                          <Fieldmik
                                                            size="mini"
                                                            transparent={!edit}
                                                            readOnly={!edit}
                                                            name={`lrInvoiceNoDetails[${index}].lrGoodsDetails[${i}].quantity`}
                                                            component={
                                                              MyNormalInput
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-2">
                                                        <div className="form-group">
                                                          <label className="w3-small">
                                                            <b>
                                                              &nbsp;&nbsp;&nbsp;&nbsp;
                                                            </b>
                                                          </label>{" "}
                                                          <br />
                                                          <Button
                                                            disabled={!edit}
                                                            hidden={
                                                              i === 0
                                                                ? true
                                                                : false
                                                            }
                                                            onClick={() =>
                                                              arrayGoods.remove(
                                                                i
                                                              )
                                                            }
                                                            size="sm"
                                                            variant="outline-danger"
                                                          >
                                                            <i className="fa fa-trash"></i>
                                                          </Button>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                                <div className="col-md-2">
                                                  {" "}
                                                  <Button
                                                    disabled={!edit}
                                                    onClick={() =>
                                                      arrayGoods.push({
                                                        lrGoodsDetails: [
                                                          {
                                                            goodsCode: "",
                                                            packagingCode: "",
                                                            categoryCode: "",
                                                            quantity: "",
                                                          },
                                                        ],
                                                      })
                                                    }
                                                    size="sm"
                                                    className="ml-2 w3-tiny mb-2"
                                                    variant="outline-info"
                                                  >
                                                    <i className="fa fa-plus"></i>{" "}
                                                    Add Product
                                                  </Button>
                                                </div>
                                              </div>
                                            )}
                                          />
                                        </div>
                                      </div>
                                    )
                                  )}
                                  <div className="col-md-3">
                                    <Button
                                      disabled={!edit}
                                      onClick={() =>
                                        arrayHelpers.push({
                                          ewayBillNumber: "",
                                          ewayBillExpiryDate: "",
                                          goodsValue: "",
                                          goodsInvoiceNo: "",
                                          goodsInvoiceDate: "",
                                          lrGoodsDetails: [
                                            {
                                              goodsCode: "",
                                              packagingCode: "",
                                              categoryCode: "",
                                              quantity: "",
                                            },
                                          ],
                                        })
                                      }
                                      size="sm"
                                      className="ml-2 w3-tiny"
                                      variant="outline-success"
                                    >
                                      <i className="fa fa-plus"></i> Add Invoice
                                    </Button>
                                  </div>
                                </>
                              )}
                            />
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="w3-small">
                                <b>Remarks</b>
                              </label>
                              <Fieldmik
                                size="mini"
                                fluid
                                className="w3-small"
                                style={{
                                  border: edit == false ? "none" : "",
                                  resize: edit == false ? "none" : "",
                                }}
                                readOnly={!edit}
                                component={MyTextArea}
                                name="remarks"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <Button
                          size="sm"
                          type="button"
                          variant="secondary"
                          onClick={this.props.handleClose}
                        >
                          Close
                        </Button>
                        {edit ? (
                          <Button
                            size="sm"
                            disabled={isSubmitting}
                            type="submit"
                            variant="primary"
                          >
                            {isSubmitting ? "Loading..." : "Save"}
                          </Button>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Modal.Content>
          </Modal>
        </div>
      );
    }
  }
}
